import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Heart, Share2, Music, Clock } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Database } from "@/integrations/supabase/types";

type SharedPlaylist = Database['public']['Tables']['shared_playlists']['Row'];

interface SharedPlaylistCardProps {
  playlist: SharedPlaylist;
  onLike: (id: string) => void;
  onShare: (code: string) => void;
  onPlay?: (playlist: SharedPlaylist) => void;
}

export const SharedPlaylistCard = ({
  playlist,
  onLike,
  onShare,
  onPlay,
}: SharedPlaylistCardProps) => {
  const trackCount = Array.isArray(playlist.tracks) ? playlist.tracks.length : 0;

  return (
    <Card className="p-4 space-y-3 hover:bg-accent/50 transition-colors">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold truncate">{playlist.name}</h3>
          {playlist.description && (
            <p className="text-sm text-muted-foreground line-clamp-2 mt-1">
              {playlist.description}
            </p>
          )}
        </div>
        <Badge variant="outline" className="shrink-0 ml-2">
          {trackCount} músicas
        </Badge>
      </div>

      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <Clock className="w-3 h-3" />
        <span>
          {formatDistanceToNow(new Date(playlist.created_at), {
            addSuffix: true,
            locale: ptBR,
          })}
        </span>
      </div>

      <div className="flex items-center justify-between pt-2 border-t">
        <div className="flex gap-2">
          <Button
            size="sm"
            variant="ghost"
            onClick={() => onLike(playlist.id)}
            className="gap-1"
          >
            <Heart className="w-4 h-4" />
            <span>{playlist.likes_count}</span>
          </Button>
          <Button
            size="sm"
            variant="ghost"
            onClick={() => onShare(playlist.share_code)}
            className="gap-1"
          >
            <Share2 className="w-4 h-4" />
            Compartilhar
          </Button>
        </div>
        {onPlay && (
          <Button
            size="sm"
            onClick={() => onPlay(playlist)}
            className="gap-1"
          >
            <Music className="w-4 h-4" />
            Ouvir
          </Button>
        )}
      </div>
    </Card>
  );
};
